// End-of-game pieces every cabinet shares: the frog warning shown when a
// cabinet is not cleared, and the label of the button that moves on.

import { FROG_MIN_SUPPORTS, FROG_SUPPORTS, arcadeScenarioId, nextTarget, supportsLeft, useArcadeProgress } from "./results";
import "./arcade.css";
import { tx, txr } from "../../lib/tx";

const NEXT_NAME: Record<string, string> = {
  turkey: "TURKEY HUNT",
  fraud: "SPOT THE FRAUD",
  invaders: "CYBER INVADERS",
};

/** Label of the leave button on an end screen: the next stop on the guided tour, else the hall. */
export function useMoveOnLabel(): string {
  const p = useArcadeProgress(arcadeScenarioId());
  if (p.mode !== "guided") return "RETURN TO ARCADE";
  const next = nextTarget(p);
  return next === "tv" ? "GO TO THE TV" : `NEXT GAME: ${NEXT_NAME[next] ?? "NEXT CABINET"}`;
}

/** Warning when a cabinet is not cleared: moving on now breaks one of the frog's supports. */
export function FrogWarning() {
  const left = supportsLeft(useArcadeProgress(arcadeScenarioId()));
  const falls = left < FROG_MIN_SUPPORTS;
  return (
    <div className="arc-frogwarn" role="alert">
      <b>{tx("THE FROG IS IN DANGER")}</b>
      <span>
        {txr("{v} Try again, or move on and take the risk.", { v: falls
          ? tx("Not cleared: only {left} of {FROG_SUPPORTS} supports would hold, so the frog falls unless you try again.", { left, FROG_SUPPORTS })
          : tx("Not cleared: this cabinet breaks one support. {left} of {FROG_SUPPORTS} still hold; one more break and the frog falls.", { left, FROG_SUPPORTS }) })}
      </span>
    </div>
  );
}
